import { IButtonElement } from "@faire/web-api/indigofair/data/IButtonElement";
import { ITextElement } from "@faire/web-api/indigofair/data/ITextElement";
import { Column, Row } from "@faire/web/slate/Layout";
import React from "react";

import { SDUIComponentInstanceRendererProps } from "@faire/retailer/components/SDUI/__internal__/types";
import { SDUICarouselButton } from "@faire/retailer/components/SDUI/ComponentRenderers/Carousel/__internal__/SDUICarouselButton";
import * as carouselStyles from "@faire/retailer/components/SDUI/ComponentRenderers/Carousel/__internal__/styles.css";
import { SDUITypographyRenderer } from "@faire/retailer/components/SDUI/ComponentRenderers/Typography/SDUITypographyRenderer";

interface IProps
  extends Pick<SDUIComponentInstanceRendererProps, "loggingData"> {
  title?: ITextElement;
  cta_button?: IButtonElement;
  sub_title?: ITextElement;
  tagline?: ITextElement;
}

export const SDUICarouselHeaderRow: React.FC<IProps> = ({
  title,
  cta_button,
  sub_title,
  tagline,
  loggingData,
}) => {
  return (
    <Row className={carouselStyles.carouselHeaderRow}>
      <Column className={carouselStyles.carouselTitleContainer}>
        {tagline ? (
          <SDUITypographyRenderer
            textElement={tagline}
            loggingData={loggingData}
          />
        ) : null}
        {title ? (
          <SDUITypographyRenderer
            textElement={title}
            loggingData={loggingData}
          />
        ) : null}
        {sub_title ? (
          <SDUITypographyRenderer
            textElement={sub_title}
            loggingData={loggingData}
          />
        ) : null}
      </Column>
      {cta_button ? (
        <SDUICarouselButton button={cta_button} loggingData={loggingData} />
      ) : null}
    </Row>
  );
};
